<template>
    <div style="text-align: center">
        <v-btn outline small color="teal" dark fab @click="reset"><v-icon>restore</v-icon></v-btn>
        <v-btn outline large fab color="red" @click="resetStart"><div style="font-size:45px">{{ initialTime }}</div></v-btn>
        <v-btn outline small color="teal" dark fab @click='start'><v-icon>{{btnLabelStart}}</v-icon></v-btn>
    </div>
</template>

<script>
export default {
    name: 'ptkAttackTime',
    data: () => ({
        initialTime: 20,
        btnLabelStart: 'play_arrow',
        attackTime: undefined,
        started: false,
        startSound: undefined,
        tenSecsSound: undefined,
        beepSound: undefined,
        endSound: undefined
    }),
    methods: {
        start(){
            clearInterval(this.attackTime)
            if(this.initialTime > 0){
                this.btnLabelStart = this.btnLabelStart == 'play_arrow' ? 'pause' : 'play_arrow'
            }
            if(!this.started){
                if(this.initialTime == 0){
                    this.initialTime = 20
                }
                if(this.initialTime == 20){
                  this.playSound("start")  
                }
                if(this.initialTime > 0){
                    this.started = true
                    this.attackTime = setInterval(function() {
                        this.initialTime = this.initialTime - 1
                        if(this.initialTime == 10){
                            this.playSound("10secs")
                        }
                        if(this.initialTime == 0){
                            this.playSound("end")
                            clearInterval(this.attackTime)
                            this.btnLabelStart = 'play_arrow'
                            this.started = false
                        }
                    }.bind(this), 1000);
                }
            } else {
                this.started = false
                clearInterval(this.attackTime)
                    this.attackTime = undefined
            }
        },
        reset(){
            this.btnLabelStart = 'play_arrow'
            this.initialTime = 20
            this.started = false
            clearInterval(this.attackTime)
        },
        resetStart(){
            this.reset()
            this.start()
        },
        playSound (sound) {
            if(sound == "start") {
                 this.startSound.play()
            }
            if(sound == "10secs") {
                this.tenSecsSound.play()
            }
            if(sound == "beeep") {
                this.beepSound.play()
            }
            if(sound == "end") {
                this.endSound.play()
            }
      }
    },
    mounted: function () {
        this.startSound = new Audio("/static/sounds/start.wav")
        this.tenSecsSound = new Audio("/static/sounds/10secs.mp3")
        this.beepSound = new Audio("/static/sounds/beep.wav")
        this.endSound = new Audio("/static/sounds/end.wav")
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ptkAttackTime.vue